class ElFaqAccordion {
  constructor(section) {
    this.section = section;
    this.items = Array.from(section.querySelectorAll(".el-faq-accordion__item"));
    this.init();
  }

  init() {
    if (!this.items.length) return;

    this.items.forEach((item) => {
      const button = item.querySelector(".el-faq-accordion__summary");
      const content = item.querySelector(".el-faq-accordion__content");

      if (!button || !content) return;

      item.dataset.elFaqState = item.classList.contains("is-open") ? "open" : "closed";
      button.setAttribute("aria-expanded", item.classList.contains("is-open") ? "true" : "false");
      content.style.height = item.classList.contains("is-open") ? "auto" : "0px";

      button.addEventListener("click", () => {
        const isOpen = item.dataset.elFaqState === "open" || item.dataset.elFaqState === "opening";

        this.items.forEach((otherItem) => {
          if (otherItem !== item) this.close(otherItem);
        });

        if (isOpen) {
          this.close(item);
        } else {
          this.open(item);
        }
      });
    });
  }

  open(item) {
    const button = item.querySelector(".el-faq-accordion__summary");
    const content = item.querySelector(".el-faq-accordion__content");

    if (!button || !content) return;
    if (item.dataset.elFaqState === "open" || item.dataset.elFaqState === "opening") return;

    this.cancelTransition(content);

    item.dataset.elFaqState = "opening";
    item.classList.add("is-open");
    button.setAttribute("aria-expanded", "true");

    const currentHeight = content.offsetHeight;

    content.style.height = `${currentHeight}px`;

    content._elFaqRaf = requestAnimationFrame(() => {
      content.style.height = `${content.scrollHeight}px`;
    });

    content._elFaqTransition = (event) => {
      if (event.propertyName !== "height") return;
      if (item.dataset.elFaqState !== "opening") return;

      content.style.height = "auto";
      item.dataset.elFaqState = "open";

      content.removeEventListener("transitionend", content._elFaqTransition);
      content._elFaqTransition = null;
    };

    content.addEventListener("transitionend", content._elFaqTransition);
  }

  close(item) {
    const button = item.querySelector(".el-faq-accordion__summary");
    const content = item.querySelector(".el-faq-accordion__content");

    if (!button || !content) return;
    if (item.dataset.elFaqState === "closed" || item.dataset.elFaqState === "closing") return;

    this.cancelTransition(content);

    item.dataset.elFaqState = "closing";
    button.setAttribute("aria-expanded", "false");

    content.style.height = `${content.offsetHeight}px`;

    content.offsetHeight;

    content._elFaqRaf = requestAnimationFrame(() => {
      content.style.height = "0px";
    });

    content._elFaqTransition = (event) => {
      if (event.propertyName !== "height") return;
      if (item.dataset.elFaqState !== "closing") return;

      item.classList.remove("is-open");
      item.dataset.elFaqState = "closed";
      content.style.height = "0px";

      content.removeEventListener("transitionend", content._elFaqTransition);
      content._elFaqTransition = null;
    };

    content.addEventListener("transitionend", content._elFaqTransition);
  }

  cancelTransition(content) {
    if (content._elFaqRaf) {
      cancelAnimationFrame(content._elFaqRaf);
      content._elFaqRaf = null;
    }

    if (content._elFaqTransition) {
      content.removeEventListener("transitionend", content._elFaqTransition);
      content._elFaqTransition = null;
    }
  }
}

function initElFaqAccordion(scope = document) {
  scope.querySelectorAll("[data-el-faq-accordion]").forEach((section) => {
    if (section.dataset.elFaqAccordionInit === "true") return;

    section.dataset.elFaqAccordionInit = "true";
    new ElFaqAccordion(section);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initElFaqAccordion();
});

document.addEventListener("shopify:section:load", (event) => {
  initElFaqAccordion(event.target);
});